module.exports = __webpack_public_path__ + "static/media/Icons_Github_dark.52d58ed7.svg";